import {Box, Grid, Option, Typography} from '@logistics-frontend/blocks'
import React from 'react'

import {classes} from './DetailsList.classes'

type Props = {
  items: Option[]
  title: string
  flexGrow?: boolean
  subtitle?: string
}

const DetailsList: React.FC<Props> = ({items, title, flexGrow, subtitle}) => {
  if (!items.length) {
    return null
  }

  return (
    <Grid xs={flexGrow ? flexGrow : 6} item>
      <Typography className={classes.title} Component={Grid} size="xs" thickness="medium" variant="body2" container>
        <Grid item>{title}</Grid>
        {subtitle && (
          <Grid item>
            <Typography color="minor" variant="caption1">
              {subtitle}
            </Typography>
          </Grid>
        )}
      </Typography>
      <Box className={classes.container} flexDirection="column">
        {items.map(({label, value}, index) =>
          value ? (
            <Grid
              key={index.toString()}
              alignItems="center"
              className={classes.item}
              justify="space-between"
              wrap="nowrap"
              container
            >
              <Typography className={classes.label} flexGrow={1} variant="caption1">
                {label}
              </Typography>
              <Typography variant="body2" whiteSpace="nowrap">
                {value}
              </Typography>
            </Grid>
          ) : null,
        )}
      </Box>
    </Grid>
  )
}

export default DetailsList
